import type { ScreenshotRef } from "../screenshots";
import type { ProcessInstance, ProcessStep } from "./processGraphModel";

export const screenshotRefsForSteps = (
  recordingId: string,
  userId: string,
  steps: ProcessStep[],
): ScreenshotRef[] =>
  steps.flatMap(step =>
    (step.screenshots ?? []).map(filename => ({
      recordingId,
      userId,
      filename,
    })),
  );

export const screenshotRefsForInstance = (instance: ProcessInstance): ScreenshotRef[] =>
  screenshotRefsForSteps(instance.source.recordingId, instance.source.userId, instance.steps);
